import React, { useState, useEffect, useRef } from 'react';
import { apiUrl } from '../../config/api';

export default function DeliveryAttempts({ attempts = [], endpoint, headers, onResolved }) {
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const [evidence, setEvidence] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const unresolved = attempts.filter(attempt => ['sending', 'uncertain', 'reconciling'].includes(attempt.status));
  if (!unresolved.length) return null;
  async function resolve(attempt, outcome) {
    setBusy(true); setError('');
    try {
      const response = await fetch(apiUrl(`${endpoint}/${encodeURIComponent(attempt.operation_key)}/reconcile`), {
        method: 'POST', headers: headers(), body: JSON.stringify({ outcome, evidence }),
      });
      const data = await response.json();
      if (!response.ok || !data.success) throw new Error(data.message || 'No se pudo guardar la verificación.');
      if (mounted.current) { setEvidence(''); await onResolved?.(); }
    } catch (err) { if (mounted.current) setError(err.message); }
    finally { if (mounted.current) setBusy(false); }
  }
  return <aside className="delivery-attempts" role="status">
    <strong>Respuesta pendiente de confirmar</strong>
    <p>Revisa en la bandeja original o en Enviados si esta respuesta llegó a enviarse.</p>
    <label>Cómo verificaste el envío<input aria-label="Evidencia de verificación del envío" placeholder="Ej.: revisé el mensaje enviado y su hora" value={evidence} onChange={event => setEvidence(event.target.value)} /></label>
    {unresolved.map(attempt => <div className="delivery-attempts__item" key={attempt.operation_key}>
      <p>{attempt.payload?.bodyText}</p>
      <button type="button" disabled={busy || evidence.trim().length < 10} onClick={() => resolve(attempt, 'sent')}>Confirmé que se envió</button>
      <button type="button" disabled={busy || evidence.trim().length < 10} onClick={() => resolve(attempt, 'not_sent')}>Confirmé que no se envió</button>
    </div>)}
    {error && <p role="alert">{error}</p>}
  </aside>;
}
